import React, { useState, useEffect } from "react";
import { Button, Row, Col, Modal, Tooltip, OverlayTrigger, Accordion, Card } from 'react-bootstrap'
import AuthService from "../../controllers/AuthService";
import UserService from "../../controllers/UserService";
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronCircleDown, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import $ from 'jquery'


const PersonEvaluate = props => {
    const { roomId, PersonId } = useParams();
    const [headline, setHeadline] = useState('เราเห็นอุปนิสัยเชิงบวกอะไรในตัวเพื่อน?');
    const [description, setDescription] = useState('หลายเรื่องราวที่เราได้พูดคุยกับเพื่อน ได้มองเห็นเพื่อนเรามองว่าอุปนิสัยเชิงบวกที่เราสัมผัสได้เกี่ยวกับเพื่อนมีอะไรบ้าง');
    const [questionTextBox, setQuestionTextBox] = useState('ลองเล่าเหตุการณ์ที่ทำให้เรามองเห็นอุปนิสัยเชิงบวกของเพื่อน');
    const [questionStrength, setQuestionStrength] = useState('');
    const [modalShow, setModalShow] = useState(false);
    const [logoPath, setLogoPath] = useState('');
    const [name, setName] = useState('');
    const [strengths, setStrengths] = useState([]);
    const [answer, setAnswer] = useState([]);
    const [postAnswer, setPostAnswer] = useState([]);
    const [targetId, setTargetId] = useState(null);
    const [modalAnswer, setModalAnswer] = useState(null);
    const [iconChooseIndex, setIconChooseIndex] = useState(null);
    const [modalChooseIndex, setModalChooseIndex] = useState(null);
    const [modalShowEndActivity, setModalShowEndActivity] = useState(false);
    const [modalShowEndActivityType, setModalShowEndActivityType] = useState('');
    const [strengthQuestion, setStrengthQuestion] = useState('ลองค้นหาอุปนิสัยเชิงบวกในตัวของเพื่อน');
    const [alreadyAnswer, setAlreadyAnswer] = useState(false);
    const handleActiveIndex = (index) => { if ($(`${index}.card.active`)[0]) { $('.card').removeClass('active'); } else { $('.card').removeClass('active'); $(index).addClass('active'); } };
    const [urlNext, setUrlNext] = useState('');
    let percent = 0
    let limit = 0

    useEffect(() => {
        const userId = AuthService.getCurrentUser().id
        var filter = {};

        setAnswer([
            { 'answer': '', 'image': '', 'name': '', 'description': '' },
            { 'answer': '', 'image': '', 'name': '', 'description': '' },
            { 'answer': '', 'image': '', 'name': '', 'description': '' },
            { 'answer': '' }
        ])
        try {
            
            // setLogoPath(UserService.getLogoUrl());          
            UserService.getRoomDetail(roomId).then((response) => {
                filter = {
                    "roomId": roomId,
                    "year": response.data.data.year,
                    "term": response.data.data.term,
                };
            }).then(() => {
                UserService.getStrengths().then((response) => {
                    setStrengths(response.data.data)
                    return response.data.data
                }).then((apiStrengths) => {
                    UserService.getFriendShipList(userId, filter).then((response) => {

                        if (response.data.status.code === 'SUCCESS' && response.data.data && response.data && response.data.data[0] && response.data.data[0].targets) {

                            const targets = response.data.data[0].targets
                            const index = targets.findIndex(target => target.user.id === PersonId);
                            const data = targets[index]
                            const role = data.user.roles[0];

                            let indexNext = targets.findIndex(target => (target.answers === null && PersonId !== target.user.id));

                            if (indexNext >= 0) {
                                let dataNext = targets[indexNext];
                                let nextUrl = '/evaluate/person/' + roomId + '/' + dataNext.user.id;
                                ///evaluate/person/64437a8182671e2305f29363/64437a8382671e2305f2936c
                                setUrlNext(nextUrl);
                            }


                            if (data.answers && data.answers.length > 0) {
                                setAlreadyAnswer(true)
                                handleAlreadyAnswer(apiStrengths, data.answers)
                                limit = 100;
                                percent = 0;
                                $('.circlePercent').removeClass('d-none');
                            }
                            let schoolImage = 3;
                            // fix icon for teacher and me
                            if (role === 'TEACHER') {
                                schoolImage = 2
                                setStrengthQuestion('ลองค้นหาอุปนิสัยเชิงบวกในตัวของคุณครู')
                                setHeadline('เรามองเห็นอุปนิสัยเชิงบวกอะไรในตัวคุณครูประจำชั้นของเราบ้างนะ?')
                                setQuestionTextBox('ลองเล่าเหตุการณ์ที่ทำให้เรามองเห็นอุปนิสัยเชิงบวกของคุณครู')
                                setDescription('มีเรื่องราวมากมายที่เกิดขึ้นในโรงเรียน หลายเรื่องราวที่เราได้พูดคุยกับคุณครูประจำชั้น แล้วตลอดช่วงเวลาที่ผ่านมา เราได้มองเห็นอุปนิสัยเชิงบวกอะไรในตัวคุณครูประจำชั้นของเราบ้าง ลองเล่าให้ฟังหน่อยนะคะ')
                            } else if (data.user.id === userId) {
                                schoolImage = 1
                                setStrengthQuestion('ค้นหาอุปนิสัยเชิงบวกที่มองเห็นในตัวเอง')
                                setHeadline('เราเห็นอุปนิสัยเชิงบวกอะไรในตัวเราบ้างนะ?')
                                setQuestionTextBox('ลองเล่าเหตุการณ์ที่ทำให้เรามองเห็นอุปนิสัยเชิงบวกของตัวเอง')
                                setDescription('ในช่วงที่ผ่านมา มีเหตุการณ์มากมายที่เกิดขึ้นกับตัวเรา แล้วจากเหตุการณ์ที่ผ่านมาทั้งหมดนั้น ทำให้เรามองเห็นอุปนิสัยเชิงบวกอะไรเกิดขึ้นในตัวเองบ้าง? ลองเล่าให้ฟังหน่อยนะคะ')
                            }
                            setTargetId(data.user.id)
                            setName(data.user.fullName)
                            setLogoPath(`/images/evaluate/school_${schoolImage}.png`)
                        }
                    }).then(() => {
                        if (limit === 100) {
                            animate();
                        }
                    });
                });
            });


            UserService.getEvaluationForms('default').then((res) => {
                if (res.data && res.data.status && res.data.status.code === "SUCCESS") {
                    // setHeadline(res.data.data.headline)
                    // setDescription(res.data.data.description)
                    // setQuestionTextBox(res.data.data.questions[3].title)
                    setPostAnswer([
                        {
                            "title": res.data.data.questions[0].title,
                            "type": res.data.data.questions[0].type,
                            "values": []
                        },
                        {
                            "title": res.data.data.questions[1].title,
                            "type": res.data.data.questions[1].type,
                            "values": []
                        },
                        {
                            "title": res.data.data.questions[2].title,
                            "type": res.data.data.questions[2].type,
                            "values": []
                        },
                        {
                            "title": res.data.data.questions[3].title,
                            "type": res.data.data.questions[3].type,
                            "values": []
                        }
                    ])
                    setQuestionStrength([
                        res.data.data.questions[0].title,
                        res.data.data.questions[1].title,
                        res.data.data.questions[2].title
                        // 'อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา',
                        // 'อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา',
                        // 'อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา'
                    ])
                }
            })
        } catch (error) {

        }


    }, [])

    return (
        <div >
            <Row className="bg-light-blue">
                <Col xs={12} md={12} className="w-100 text-center pt-4 ">
                    <h2 class="font-sarabun-bold primary-text " >{headline} </h2>
                </Col>
            </Row>
            <Row style={{ "paddingBottom": "17px" }} className="bg-light-blue">
                <Col className="main-evaluate-overview pb-3">
                    <Row>
                        <Col xs={12} md={12} className="w-100 m-center-d-left pt-3">
                            <h4 class="font-sarabun-bold text-left">{description}</h4>
                        </Col>
                        <Col xs={12} md={12} className="text-center p-0 ">
                            <div className="bg-evaluate">
                                <div class="evaluate-position-absolute w-100">
                                    <div class={`circlePercent ${percent === 0 ? 'd-none' : ''}`}>
                                        <div class="counter" data-percent="0"></div>
                                        <div class="progress"></div>
                                        <div class="progressEnd"></div>
                                    </div>
                                    <div class="div-percent-image w-100">
                                        <img src={logoPath} class="percent-image" alt="" />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="">
                <Col className="main-evaluate-overview">
                    <Row className="mx-2">
                        <Col xs={12} md={12} className="evaluate-person">
                            <div class="text-center p-1 px-3 bg-lightness2-blue border-radius-12 border-blue font-sarabun-bold" style={{ "width": "fit-content", "margin": "auto" }}>{name}</div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="pb-5">
                <Col className="main-evaluate-overview">
                    <Row>
                        <Col className="w-100 text-center">

                            <h4 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search" />  {strengthQuestion}</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                        </Col>
                    </Row>
                    <Row className="mx-3 mb-3 strengths-box">
                        <Col xs={4} md={4} className="text-center px-0 py-1">
                            <img src={(answer[0] && answer[0].image) ? answer[0].image : '/images/evaluate/question.png'} className="w-100 pt-1 px-md-2 pb-md-2 w-100 click-pointer" onClick={() => { focusChooseStrengthModal(0); }} />
                            {(!alreadyAnswer && answer[0] && answer[0].answer) &&
                                (<a href="javascript:;" onClick={() => { callChooseStrengthModal(0); }}><img src="/images/icons/pencil.png" className="edit" />แก้ไข</a>)}
                        </Col>
                        <Col xs={4} md={4} className="text-center px-0 py-1">
                            <img src={(answer[1] && answer[1].image) ? answer[1].image : '/images/evaluate/question.png'} className="w-100 pt-1 px-md-2 pb-md-2 w-100 click-pointer" onClick={() => { focusChooseStrengthModal(1); }} />
                            {(!alreadyAnswer && answer[1] && answer[1].answer) &&
                                (<a href="javascript:;" onClick={() => { callChooseStrengthModal(1); }}><img src="/images/icons/pencil.png" className="edit" />แก้ไข</a>)}
                        </Col>
                        <Col xs={4} md={4} className="text-center px-0 py-1">
                            <img src={(answer[2] && answer[2].image) ? answer[2].image : '/images/evaluate/question.png'} className="w-100 pt-1 px-md-2 pb-md-2 w-100 click-pointer" onClick={() => { focusChooseStrengthModal(2); }} />
                            {(!alreadyAnswer && answer[2] && answer[2].answer) &&
                                (<a href="javascript:;" onClick={() => { callChooseStrengthModal(2); }}><img src="/images/icons/pencil.png" className="edit" />แก้ไข</a>)}
                        </Col>
                    </Row>
                    {
                        (answer[iconChooseIndex]) ?
                            <Row>
                                <Col className="w-100 px-4 mb-4">
                                    <div className="answer-detail">
                                        {
                                            (iconChooseIndex !== null && questionStrength[iconChooseIndex]) ?
                                                <h5 className="choice" align="center">
                                                    {/* {questionStrength[iconChooseIndex]} */}
                                                    อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา
                                                </h5>
                                                :
                                                <span></span>
                                        }
                                        {
                                            (answer[iconChooseIndex] && answer[iconChooseIndex].description) ?
                                                <div>
                                                    <h5 className="title" align="center">
                                                        {answer[iconChooseIndex].name}
                                                    </h5>
                                                    <p>{answer[iconChooseIndex].description}</p>
                                                </div>
                                                :
                                                <span></span>
                                        }
                                    </div>
                                </Col>
                            </Row>
                            :
                            <div></div>
                    }

                    <Row>
                        <Col className="w-100 px-4 text-center">
                            <h4 class="font-sarabun-bold">{questionTextBox}</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="w-100 px-4 pt-1">
                            <div className={`border-radius-12 border-blue p-3 text-left overflow-7 ${alreadyAnswer ? 'div-ans auto-height' : 'bg-white'}`}>
                                {(alreadyAnswer) ?
                                    <div className="font-sarabun">{answer && answer[3] && answer[3].answer ? answer[3].answer : ''}</div>

                                    :
                                    <textarea className={`w-100 text no-border-line evaluate-placeholder ${alreadyAnswer ? 'div-ans' : ''}`} value={answer && answer[3] && answer[3].answer ? answer[3].answer : ''} placeholder="ลองเล่าให้เราฟังหน่อย..." style={{ height: '170px' }} onChange={handleTextAnswer} readOnly={alreadyAnswer}></textarea>
                                }
                            </div>
                        </Col>
                    </Row>
                    {
                        (!alreadyAnswer) ?
                            <Row>
                                <Col xs={12} className="px-3 pt-4 pb-3 d-inline w-100 text-center">
                                    <Button className="bluesky d-inline py-1 py-1 py-md-2 btn font-sarabun-bold" onClick={() => { validateForm(); }} >บันทึก</Button>
                                </Col>
                            </Row>
                            :
                            <div></div>
                    }


                </Col>
            </Row>

            <MyVerticallyCenteredModal
                show={modalShow}
                onShow={() => {preventDoubleAnswer()}}
                onHide={() => { setModalShow(false); setModalAnswer(null); }}
            />
            <Modal
                show={modalShowEndActivity}
                onHide={() => { setModalShowEndActivity(false); }}
                aria-labelledby="contained-modal-title-vcenter"
                // className="strength-modal"
                centered
                className="alert-modal"
            >

                {/* { (modalShowEndActivityType === 'validate') ? (
                <Modal.Body className="font-sarabun text-center py-4">
                    <p>กรุณาค้นหาอุปนิสัยเชิงบวกให้ครบก่อนจะทำการบันทึก</p>
                    <Button className="bluebtn d-inline py-1 py-md-2 px-3 font-sarabun-bold border-radius-10" onClick={() => { setModalShowEndActivity(false); }}>กลับกิจกรรม</Button>
                </Modal.Body>
                ) : (
                    <Modal.Body className="font-sarabun text-center py-4">
                        <p>ระบบได้ทำการบันทึกข้อมูลเรียบร้อยแล้วค่ะ</p>
                        <Button className="bluebtn d-inline py-1 py-md-2 px-3 font-sarabun-bold border-radius-10" onClick={() => { gotoNextPage(); }}>ตกลง</Button>
                    </Modal.Body>
                )} */}


                {modalShowEndActivityType === 'validate' ? (
                    <Modal.Body className="font-sarabun text-center py-4">
                        <p>กรุณาค้นหาอุปนิสัยเชิงบวกให้ครบก่อนจะทำการบันทึก</p>
                        <Button className="bluebtn d-inline py-1 py-md-2 px-3 font-sarabun-bold border-radius-10" data-testid="evaluate-back-url" onClick={() => { setModalShowEndActivity(false); }}>กลับกิจกรรม</Button>
                    </Modal.Body>
                ) : (urlNext !== '') ? (
                    <Modal.Body className="font-sarabun text-center py-4">
                        <img src='/images/evaluate/nextPerson.png' class="percent-image" alt="" />
                        <p>เพื่อความสะดวก<br></br>รวดเร็วสามารถประเมินคนต่อไปได้ทันที</p>
                        <Button className="bluebtn d-inline py-1 py-md-2 px-3 font-sarabun-bold border-radius-10" data-testid="evaluate-next-url" onClick={() => { gotoNextURL(); }}>ประเมินต่อ</Button>
                    </Modal.Body>
                ) : (
                    <Modal.Body className="font-sarabun text-center py-4">
                        <p>ระบบได้ทำการบันทึกข้อมูลเรียบร้อยแล้วค่ะ</p>
                        <Button className="bluebtn d-inline py-1 py-md-2 px-3 font-sarabun-bold border-radius-10" data-testid="evaluate-ok-url" onClick={() => { gotoNextPage(); }}>ตกลง</Button>
                    </Modal.Body>
                )}

            </Modal>
        </div>
    );

    function gotoNextPage() {
        window.location.href = `/evaluate/overview/${roomId}`
    }

    function gotoNextURL() {
        window.location.href = `${urlNext}`
    }

    function callChooseStrengthModal(index) {
        if (!alreadyAnswer) {
            setModalShow(true);
            setModalAnswer(index);
            setModalChooseIndex(index);
        }
    }

    function focusChooseStrengthModal(index) {
        const answerData = [...answer]
        if (answerData && answerData.length > 0 && answerData[index] && answerData[index].answer) {
            for (let [i, val] of answerData.entries()) {
                if (i !== index && val.image) {
                    val.image = val.image.replace("/active", "/inactive");
                }
            }
            answerData[index].image = answerData[index].image.replace("/inactive", "/active");
            setAnswer(answerData)
            setIconChooseIndex(index)
        } else {
            setModalShow(true);
            setModalAnswer(index);
            setModalChooseIndex(index);
        }
    }

    function handleAlreadyAnswer(apiStrengths, answers) {
        const str0 = apiStrengths.filter(function (strength) { return strength.id === answers[0].values[0] })[0];
        const str1 = apiStrengths.filter(function (strength) { return strength.id === answers[1].values[0] })[0];
        const str2 = apiStrengths.filter(function (strength) { return strength.id === answers[2].values[0] })[0];
        if (str0 && str0.imageUrl && str1 && str1.imageUrl && str2 && str2.imageUrl) {
            const imgPath0 = str0.imageUrl.replace(/^.*[\\\/]/, '')
            const imgPath1 = str1.imageUrl.replace(/^.*[\\\/]/, '')
            const imgPath2 = str2.imageUrl.replace(/^.*[\\\/]/, '')
            setAnswer([
                { 'answer': answers[0].values[0], 'image': `/images/strengths/inactive/${imgPath0}`, 'name': str0.name, 'description': str0.description },
                { 'answer': answers[1].values[0], 'image': `/images/strengths/inactive/${imgPath1}`, 'name': str1.name, 'description': str1.description },
                { 'answer': answers[2].values[0], 'image': `/images/strengths/inactive/${imgPath2}`, 'name': str2.name, 'description': str2.description },
                { 'answer': answers[3].values[0] }
            ])
            checkPercentAnswer();
        }
    }

    function validateForm() {
        if (
            answer && answer[0] && answer[1] && answer[2] && answer[3] &&
            answer[0].answer && answer[1].answer &&
            answer[2].answer && answer[3].answer
        ) {
            saveAnswer()
        } else {
            setModalShowEndActivity(true)
            setModalShowEndActivityType('validate')
        }
    }

    function saveAnswer() {
        UserService.postPersonEvaluationForms({
            "userId": AuthService.getCurrentUserId(),
            "targetId": targetId,
            "roomId": AuthService.getCurrentUser().room.id,
            "answers": postAnswer
        },
            (error) => {
                const resMessage =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();
                if (error.response && error.response.data && error.response.data.status && error.response.data.status.code === 'UNAUTHORIZED') {
                    AuthService.logout();
                    window.location.href = '/login'
                } else {
                    alert(`เกิดข้อผิดพลาดบางอย่าง กรุณา capture หน้าจอนี้แล้วแจ้งผู้ประสานงาน : ${resMessage}`)
                }
            }).then((res) => {
                console.log(res)
                if (res.data && res.data.status.code === 'SUCCESS') {
                    setModalShowEndActivity(true)
                    setModalShowEndActivityType('complete')
                }
            })
    }

    function handleTextAnswer(event) {
        const answerData = [...answer]
        const postAnswerData = [...postAnswer]
        if (!alreadyAnswer && answerData.length > 0) {
            answerData[3].answer = event.target.value
            postAnswerData[3].values = [event.target.value]
            setAnswer(answerData)
            setPostAnswer(postAnswerData)
        }
    }

    function animate() {

        setProgress((percent += .25));
        if (percent < limit)
            setTimeout(animate, 15);
    }

    function setProgress(percent2) {
        const elem = document.querySelector('.circlePercent');
        var
            degrees = percent2 * 3.6,
            transform = /MSIE 9/.test(navigator.userAgent) ? 'msTransform' : 'transform';
        // elem.querySelector('.counter').setAttribute('data-percent', Math.round(percent));
        if (degrees >= 360) {
            elem.querySelector('.progressEnd').style[transform] = 'rotate(' + 360 + 'deg)';
        } else {
            elem.querySelector('.progressEnd').style[transform] = 'rotate(' + degrees + 'deg)';
        }
        if (degrees >= 360) {
            elem.querySelector('.progress').style[transform] = 'rotate(' + 360 + 'deg)';
        } else {
            elem.querySelector('.progress').style[transform] = 'rotate(' + degrees + 'deg)';
        }
        if (percent2 >= 50 && !/(^|\s)fiftyPlus(\s|$)/.test(elem.className)) {
            elem.className += ' fiftyPlus';
        } else if (percent2 < 50) {
            $('.circlePercent').removeClass('fiftyPlus')
        }
    }

    function MyVerticallyCenteredModal(props) {
        return (
            <Modal
                {...props}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                className="strength-modal"
                centered
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <Row className="py-3 person-choose-strength px-md-4 d-none d-md-flex">
                        <Col xs={12} align="center">
                            <h3 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search" />
                                {
                                    (questionStrength[modalChooseIndex]) ?
                                        <span>
                                            {/* {questionStrength[modalChooseIndex]} */}
                                            อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา
                                        </span>
                                        :
                                        <span></span>
                                }
                            </h3>
                        </Col>
                        {strengths.map((strength, i) => (
                            <div key={i} className="col-12 col-md-4" align="left">
                                {/* { (answer[0].answer === strength.id || answer[1].answer === strength.id || answer[2].answer === strength.id) ? (
                                    <div className="position-relative">
                                        <div className="item-overlay w-100 p-1 position-absolute border-radius-5">
                                        </div>
                                        <div className="item my-1 w-100 my-md-2 p-1 border-radius-5">
                                            <img className="step-img" width="58" src={`${strength.imageUrl}`} /> {strength.id}
                                        </div>
                                    </div>
                                ) : ( */}
                                <OverlayTrigger
                                    placement="bottom"
                                    delay={{ show: 100, hide: 300 }}
                                    overlay={
                                        <Tooltip id="button-tooltip" className="custom-bottom-tooltip" {...props}>
                                            {strength.description}
                                        </Tooltip>
                                    }
                                >
                                    <div className={`item my-1 my-md-2 p-1 click-pointer border-radius-5 font-sarabun-bold ${strength.id}`} onClick={() => { handleAnswer(strength); setModalShow(false); }}>
                                        <img className="step-img" width="58" src={strength.imageUrl} /> {strength.name}
                                    </div>
                                </OverlayTrigger>
                                {/* )} */}
                            </div>
                        ))}
                    </Row>
                    <Row className="d-flex d-md-none person-collapse">
                        <Col xs={12} align="center">
                            <h3 class="font-sarabun-bold"><img src='/images/evaluate/search.png' class="evaluate-search" />
                                {
                                    (questionStrength[modalChooseIndex]) ?
                                        <span>
                                            {/* {questionStrength[modalChooseIndex]} */}
                                            อุปนิสัยเชิงบวกที่มองเห็นในช่วงที่ผ่านมา
                                        </span>
                                        :
                                        <span></span>
                                }
                            </h3>
                        </Col>
                        <Col>
                            <Accordion>
                                {strengths.map((strength, i) => (
                                    <Card key={`mobi-${i}`} className={`mobi-${i} ${strength.id}`}>
                                        <Accordion.Toggle as={Card.Header} eventKey={i + 1} onClick={() => { handleActiveIndex(`.mobi-${i}`) }}>
                                            <img className="step-img" width="52" src={strength.imageUrl} />  {strength.name}
                                            <div class="arrow">
                                                <FontAwesomeIcon icon={faChevronDown} />
                                            </div>
                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey={i + 1}>
                                            <Card.Body>
                                                <div>
                                                    {strength.description}
                                                </div>
                                                <div align="center">
                                                    <Button className="choose-btn" onClick={() => { handleAnswer(strength); setModalShow(false); }}
                                                    // disabled={answer[0].answer === strength.id || answer[1].answer === strength.id || answer[2].answer === strength.id}
                                                    >เลือก</Button>
                                                </div>

                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                ))}
                            </Accordion>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        );
    }

    function handleAnswer(strength) {
        const answerData = [...answer]
        const postAnswerData = [...postAnswer]
        if (answerData.length > 0 && strength.id !== null && strength.imageUrl !== null) {
            for (let [i, val] of answerData.entries()) {
                if (i !== modalAnswer && val.image) {
                    val.image = val.image.replace("/active", "/inactive");
                }
            }
            answerData[modalAnswer].answer = strength.id
            answerData[modalAnswer].name = strength.name
            answerData[modalAnswer].description = strength.description
            const filename = strength.imageUrl.replace(/^.*[\\\/]/, '')
            answerData[modalAnswer].image = `/images/strengths/active/${filename}`
            postAnswerData[modalAnswer].values = [strength.id]
            console.log(postAnswerData)
            setAnswer(answerData)
            setPostAnswer(postAnswerData)
            setIconChooseIndex(modalChooseIndex)
            checkPercentAnswer()
        }
    }

    function checkPercentAnswer() {
        const answerData = [...answer]
        let countAnswer = 0
        console.log(answer)
        if (answer && answerData.length > 0) {
            for (let [i, val] of answerData.entries()) {
                if (i !== 3 && val.answer) {
                    countAnswer++
                }
            }
            console.log(countAnswer)
            if (countAnswer) {
                $('.circlePercent').removeClass('d-none')
                if (countAnswer > 3) {
                    $('.circlePercent').addClass('fiftyPlus')
                }
                percent = (countAnswer - 1) * 33.34
                limit = countAnswer * 33.34;
                animate()
            }
        }
    }

    function toggleActiveKey(event) {
        // console.log($(this))
        // $(this).addClass("a")
        console.log(event)
        let el = event.target;
        el.classList.add('active');
        // setActiveIndex2(index)
        //  if (activeIndex) {
        //     setActiveIndex(null)
        // } else if (index) {
        //     setActiveIndex(index)
        // } 
    }


    function preventDoubleAnswer() {
        $('.person-choose-strength .item').addClass('click-pointer');
        $('.person-choose-strength .item').css("pointer-events", "unset");
        $('.person-choose-strength .item').css("opacity", "1");
        var imgsrc = '';
        $(".strengths-box img.w-100").each(function() {  
            imgsrc = this.src;           
            var tempText = imgsrc.split('/');    
            tempText = tempText[tempText.length-1];
            tempText = "." + tempText.replace(".png", "");
            console.log(tempText);
            console.log( $(tempText));
            $(tempText).removeClass('click-pointer');
            $(tempText).css("pointer-events", "none");
            $(tempText).css("opacity", "0.4");         

        });  
    }

};

export default PersonEvaluate;